/**
 * Home page API contract types. Deliberately a zero-import leaf: the pure
 * state machine (`features/home/homeState.ts`) and the e2e public specs both
 * consume it without dragging the api client (typedEnv, store) into their
 * module graph.
 */

// Home vocabulary, not the product-type vocabulary: 'viewer3d' products live
// in a separate table backend-side, so a single ProductType can't express it.
export const homeCategoryKeys = ["makeup", "glasses", "viewer3d"] as const
export type HomeCategoryKey = (typeof homeCategoryKeys)[number]

export type HomeCategorySummary = {
  key: HomeCategoryKey
  productsLive: number
  productsTotal: number
}

export type HomeOnboarding = {
  demoViewedAt: string | null
  /** True when the backend derived the state from the catalog (no record yet). */
  derived: boolean
  publishConfirmedAt: string | null
  selectedCategories: HomeCategoryKey[]
}

export type AdminHomeResponse = {
  categories: HomeCategorySummary[]
  onboarding: HomeOnboarding
}

export type UpdateHomeOnboardingInput = {
  demoViewed?: true
  publishConfirmed?: true
  selectCategory?: HomeCategoryKey
}
